module.exports = __webpack_public_path__ + "img/menu-logo.14d01a2a.png";